import React, { useCallback, useEffect, useMemo, useState } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';

// GLOBAL FUNCTIONS
import { controlName } from 'functions.js';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// LOCAL FUNCTIONs
import { validateUnique } from './schema';

// STYLES
import styles from './rebateTrims.module.scss';

// MAIN COMPONENT
const RebateTrims = ({
  show,
  name
}) => {

  // FORMIK CONTEXT
  const { values, setFieldValue } = useFormikContext() || {};

  // STATE
  const [ length, setLength ] = useState(1);

  // MEMOS
  const value = useMemo(
    () => cloneDeep(get(values, name)),
    [name, values]
  )
  const canDelete = useMemo(
    () => length > 1,
    [length]
  )

  // CALLBACKS
  const addItem = useCallback(
    () => {
      setLength(length + 1);
    },
    [length, setLength]
  )
  const removeItem = useCallback(
    () => {
      setLength(length - 1);
    },
    [length, setLength]
  )
  const deleteItem = useCallback(
    i => async () => {
      if (!value) {
        removeItem();
        return;
      }
      value.splice(i, 1);
      await setFieldValue(name, value);
      removeItem();
    },
    [name, value, setFieldValue, removeItem]
  )

  // EFFECTS
  useEffect(
    () => {
      if (value?.length > length) setLength(value?.length)
    },
    [value, length, setLength]
  )

  const validationSchema = useMemo(() => {
    return validateUnique(value, 'trim_text', 'Trim Values should be Unique');
  }, [value])

  // RENDER
  return !show ? null : (
    <Form.Col colWidth={8}>
      <Form.Row>
        <Form.Col cols={{ xs: 24 }}>
          <Form.Row>
            {Array(length).fill().map((_item, i) => (
              <Form.Col key={i} className={styles.trim} cols={{ xs: 24 }}>
                <Form.Row>
                  <Form.Hidden
                    name={controlName('dealer_rebate_trim_id', name, i)}
                  />
                  <Form.Control
                    key={i}
                    name={controlName('trim_text', name, i)}
                    placeholder="Enter Trim"
                    formGroup={{
                      className: styles.formGroup
                    }}
                    required
                    fullWidth
                    validationSchema={validationSchema}
                  />
                  <Form.Col className={styles.deleteCol}>
                    {canDelete &&
                      <Button.Link
                        icon="cancel-circle"
                        onClick={deleteItem(i)}
                      />
                    }
                  </Form.Col>
                </Form.Row>
              </Form.Col>
            ))}
          </Form.Row>
        </Form.Col>
        <Form.Col className={styles.addCol}>
          <Button.Link
            icon={{
              use: 'add-circle',
              order: 1
            }}
            label="Add Trim"
            onClick={addItem}
            size="sm"
            fullWidth={false}
          />
        </Form.Col>
     </Form.Row>
    </Form.Col>
  )
}

// EXPORT
export default RebateTrims